import { LOCATION_STATUS_ENUM } from '../../shared/constants'

export const CREATE_LOCATION = 'CREATE_LOCATION'
export const CREATE_LOCATION_SUCCESS = 'CREATE_LOCATION_SUCCESS'

export const GET_LOCATION_BY_ID = 'GET_LOCATION_BY_ID'
export const GET_LOCATION_BY_ID_SUCCESS = 'GET_LOCATION_BY_ID_SUCCESS'
export const UPDATE_LOCATION_BY_ID = 'UPDATE_LOCATION_BY_ID'
export const UPDATE_LOCATION_BY_ID_SUCCESS = 'UPDATE_LOCATION_BY_ID_SUCCESS'
export const CLEAR_LOCATION_BY_ID = 'CLEAR_LOCATION_BY_ID'

export const GET_LOCATIONS_BY_CITY_ID = 'GET_LOCATIONS_BY_CITY_ID'
export const GET_LOCATIONS_BY_CITY_ID_SUCCESS =
  'GET_LOCATIONS_BY_CITY_ID_SUCCESS'
export const CLEAR_LOCATIONS_BY_CITY_ID = 'CLEAR_LOCATIONS_BY_CITY_ID'

export const SET_LOCATIONS_BY_CITY_ID_FILTER_STATUS =
  'SET_LOCATIONS_BY_CITY_ID_FILTER_STATUS'

export const SET_LOCATIONS_BY_CITY_ID_SORT_BY =
  'SET_LOCATIONS_BY_CITY_ID_SORT_BY'

export const SET_LOCATIONS_BY_CITY_ID_SEARCH_VALUE =
  'SET_LOCATIONS_BY_CITY_ID_SEARCH_VALUE'

export const GET_LOCATION_TYPES = 'GET_LOCATION_TYPES'
export const GET_LOCATION_TYPES_SUCCESS = 'GET_LOCATION_TYPES_SUCCESS'
export const STATUS_ENABLED = 'enabled'

export const ARCHIVE_LOCATION = 'ARCHIVE_LOCATION'

export const LOCATION_STATUS = [
  {
    label: 'All',
    value: null,
  },
  {
    label: 'Active',
    value: LOCATION_STATUS_ENUM.ENABLED,
  },
  {
    label: 'Archive',
    value: LOCATION_STATUS_ENUM.ARCHIVED,
  },
  {
    label: 'Disabled',
    value: LOCATION_STATUS_ENUM.DISABLED,
  },
]
